<template>
  <div class="custom-modal">
    <div v-if="displayAccount">
      <div class="custom-modal-header">
        <div class="close-modal">
          <i class="bx bx-x" @click="closeProfile"></i>
        </div>
        <div class="title">
          <h5>Stylist Account</h5>
        </div>
      </div>
      <div class="modal-body">
        <upload-profile-photo :data="$store.state.stylist" :userId="stylist.id" :type="'stylist'"></upload-profile-photo>
        <div v-bind:key="key" v-for="(action, key) in actions" class="modal-section" @click="actionMethod(key)">
          <div>
            <p>{{ key }}</p>
          </div>
          <div class="text-right">
            <p>
              <i class="fas fa-chevron-right" v-if="action.display === 'arrow'"></i>
              <span v-else>{{ formattedPaymentMethod(stylist.paymentMethod) }}</span>
            </p>
          </div>
        </div>
        <div class="modal-section"></div>
        <footer class="modal-footer">
          <button @click="signOut" class="btn btn-outline-light">LOGOUT</button>
        </footer>
      </div>
    </div>
    <div v-else-if="displayHelp">
      <div class="custom-modal-header">
        <div class="close-modal">
          <i class="fas fa-chevron-left" @click="closeSetting"></i>
        </div>
        <div class="title">
          <h5>Help</h5>
        </div>
      </div>
      <div class="modal-body">
        <div v-if="displaySubHelp">
          <div class="modal-section" @click="redirect('https://help.fashionphile.com/s/')">
            <div>
              <p>FAQ</p>
            </div>
            <div class="text-right">
              <p>
                <i class="fas fa-chevron-right"></i>
              </p>
            </div>
          </div>
          <div v-if="tutorials" class="modal-section" @click="displaySubHelp = false">
            <div>
              <p>Tutorials</p>
            </div>
            <div class="text-right">
              <p>
                <i class="fas fa-chevron-right"></i>
              </p>
            </div>
          </div>
        </div>
        <div v-else class="text-primary pt-4 pb-4">
          <label>Tutorial Categories</label>
          <select @change="updateDisplayedTutorial" v-model="selectedTutorialCategory" class="form-control">
            <option v-for="(category, index) in tutorialCategories" :key="index">{{ category }}</option>
          </select>
          <div v-if="displayedTutorials" class="mt-3">
            <tutorial :slideNumber="slideNumber" :tutorials="displayedTutorials"></tutorial>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="custom-modal-header">
        <div class="close-modal">
          <i class="fas fa-chevron-left" @click="closeSetting"></i>
        </div>
        <div class="title">
          <h5>Payout</h5>
        </div>
      </div>
      <div class="modal-body">
        <p class="text-white">{{ paymentContent['paymentSetting.overview'] }}</p>
        <h5>PAYOUT PREFERENCES <processing-spinner :saved="updatedPayment" :saving="updatingPayment"></processing-spinner></h5>
        <div>
          <div class="custom-control custom-radio mb-3">
            <input type="radio" v-model="paymentMethod" id="paymentMethodCheck" name="paymentMethod" class="custom-control-input" value="check">
            <label for="paymentMethodCheck" class="custom-control-label"><span>Check</span><br>3-5 Business days - Free</label>
          </div>
          <div class="custom-control custom-radio custom-control-right">
            <input type="radio" v-model="paymentMethod" id="paymentMethodPayPal" name="paymentMethod" class="custom-control-input" value="paypal">
            <label for="paymentMethodPayPal" class="custom-control-label">
              <span>PayPal</span>
              <br>{{ paymentContent['paymentSetting.paypal'] }}</label>
          </div>
          <div class="form-group">
            <input placeholder="Enter PayPal Address" class="form-control ml-4" type="email" name="paypalAddress" v-model="paypalAddress" autocomplete="off">
          </div>
          <button @click="updatePayment" class="btn btn-primary">SAVE PAYOUT PREFERENCE</button>
          <div class="mt-2" v-for="(errorMessage, index) in errorMessages" v-bind:key="index">
            <error-message :errorMessage="errorMessage"></error-message>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'
import { logoutUrl } from '@/services/storefront'
import ProcessingSpinner from './processing-spinner'
import UploadProfilePhoto from './shared/upload-profile-photo'
import ErrorMessage from './shared/error-message'
import Tutorial from './shared/tutorial'

export default {
  name: 'profile',
  components: { Tutorial, ErrorMessage, UploadProfilePhoto, ProcessingSpinner },
  data () {
    return {
      displayAccount: true,
      displayHelp: false,
      displaySubHelp: true,
      displayTutorials: false,
      paymentContent: this.$store.state.il8nContent,
      updatedPayment: false,
      updatingPayment: false,
      paypalAddress: this.$store.state.stylist.paypalAddress,
      paymentMethod: this.$store.state.stylist.paymentMethod,
      errorMessages: '',
      tutorials: [],
      displayedTutorials: [],
      selectedTutorialCategory: 'Welcome',
      actions: {
        'personal info': {
          display: 'arrow'
        },
        security: {
          display: 'arrow'
        },
        payout: {
          display: 'paymentMethod'
        },
        help: {
          display: 'arrow'
        },
        'terms of use': {
          display: 'arrow'
        }
      },
      stylist: this.$store.state.stylist,
      slideNumber: 0
    }
  },
  methods: {
    signOut () {
      this.closeProfile()
      this.$store.commit('logoutUser')
      window.location.href = logoutUrl()
    },
    updatePayment () {
      this.errorMessages = ''
      this.updatedPayment = false
      this.updatingPayment = true
      const self = this
      api.patch('/api/account/payment-options', {
        paypalAddress: this.paypalAddress,
        paymentMethod: this.paymentMethod
      }).then(response => {
        this.updatingPayment = false
        this.updatedPayment = true
        const updatedData = {
          paypalAddress: this.paypalAddress,
          paymentMethod: this.paymentMethod
        }
        self.$store.dispatch('updateStylistData', updatedData)
      }).catch((error) => {
        this.updatingPayment = false
        this.errorMessages = error.response.data.errors
      })
    },
    closeSetting () {
      this.displayAccount = true
      this.displayHelp = false
    },
    closeProfile () {
      this.$bvModal.hide('profile-modal')
    },
    formattedPaymentMethod (paymentMethod) {
      if (paymentMethod === 'check') {
        return 'check'
      }

      return 'PayPal'
    },
    actionMethod (action) {
      let url = ''
      switch (action) {
        case 'personal info':
          url = process.env.VUE_APP_FASHIONPHILE_API_URL + '/account/dashboard'
          break
        case 'security':
          url = process.env.VUE_APP_FASHIONPHILE_API_URL + '/account/credentials'
          break
        case 'terms of use':
          url = process.env.VUE_APP_FASHIONPHILE_API_URL + '/terms-of-use/page'
          break
        case 'help':
          this.displayHelp = true
          this.displayAccount = false
          this.displaySubHelp = true
          break
        case 'payout':
          this.displayAccount = false
          break
      }
      if (url) {
        this.redirect(url)
      }
    },
    redirect (url) {
      const data = {
        userId: this.stylist.id,
        url: url
      }
      this.$store.dispatch('authenticateAndRedirect', data)
    },
    updateDisplayedTutorial () {
      this.displayedTutorials = this.tutorials.filter(data => data.category === this.selectedTutorialCategory)
      this.slideNumber = 0
    }
  },
  mounted () {
    this.tutorials = this.$store.state.tutorials.sort((a, b) => (a.category > b.category) ? -1 : 1)
    this.updateDisplayedTutorial()
  },
  computed: {
    tutorialCategories () {
      return [...new Set(this.tutorials.map(item => item.category))]
    }
  }
}
</script>
<style scoped>
  .bx.bx-x {
    font-size: 32px;
    line-height: 32px;
  }
  .modal-section p {
    margin: 0;
    text-transform: uppercase;
  }
  .modal-body label {
    color: #FFF;
  }
  .modal-body label span {
    text-transform: uppercase;
    font-weight: bold;
    font-family: 'MetropolisBold';
  }
  .modal-section p span{
    text-transform: revert;
  }
  .modal-section {
    cursor: pointer;
  }
  .form-group {
    display: flex;
  }
  .form-control {
    flex-shrink: 1;
    background: red;
  }
</style>
